import React from 'react';
import UseResize from 'utils/hooks/useResize';
import { IBanner } from '../constants';
import style from './index.module.scss';
import cn from 'classnames';
import Contact from 'components/contact';
import CustomLink from 'components/link';

interface Props {
  more?: boolean;
  bannerList: Array<IBanner>;
}

export interface WProps {
  children: React.ReactNode;
  bannerInfo: IBanner;
}

export function WrapperBanner({ children, bannerInfo }: WProps) {
  const { styles = {} } = bannerInfo;
  const size = UseResize();
  const customClass = style[bannerInfo?.classNames || ''] ? style[bannerInfo?.classNames || ''] : bannerInfo?.classNames;
  return (
    <div className={cn(style.container, customClass)} style={{ backgroundImage: `url(${size.width < 768 ? bannerInfo.mUrl : bannerInfo.pcUrl})`, ...styles }}>
      {children}
    </div>
  );
}

const Index = (props: Props) => {
  const { bannerList } = props;
  return (
    <>
      {bannerList.map((item: IBanner, index: number) => {
        item.more = item.more ?? true;
        item.descStyle = item.descStyle || {};
        return (
          <WrapperBanner key={item.pcUrl + index} bannerInfo={item}>
            {item.isContact ? (
              <>
                <div>
                  <div className={style.title}>{item.title}</div>
                  <div className={style.desc}>{item.desc}</div>
                </div>
                <div className={style['contact-sale']}>
                  <Contact isTry={false} />
                </div>
              </>
            ) : (
              <>
                <div className={style.title} style={{ color: item?.color || '#fff' }}>
                  {item.title}
                </div>
                <div className={style.content}>
                  <div className={style.desc} style={{ ...item.descStyle, color: item?.color || '#fff' }}>
                    {item.desc}
                  </div>
                  {item.more && (
                    <CustomLink isNextLink={false} href={item.link || ''} className={style.more} styles={{ color: item?.color || '#fff' }}>
                      了解更多 &gt;
                    </CustomLink>
                  )}
                </div>
              </>
            )}
          </WrapperBanner>
        );
      })}
    </>
  );
};

export default Index;
